import clsx from 'clsx'

import { Badge } from '@wartek-id/badge'
import { Text } from '@wartek-id/text-v1'

import type { PenetapanPegawaiState } from 'types/kinerja-ps-pegawai'

type BadgeStatusPengirimanProps = {
  status: PenetapanPegawaiState
}

type ColorSpecs = { label: string; foreground: string; background: string }

const COLORS_PPK: Record<PenetapanPegawaiState, ColorSpecs> = {
  NOT_RATED: {
    label: 'Pelaksanaan Belum Selesai',
    foreground: '!text-default',
    background: '!bg-gray-10',
  },
  NOT_SENT: {
    label: 'Pelaksanaan Belum Selesai',
    foreground: '!text-default',
    background: '!bg-gray-10',
  },
  SENT_TO_PPK: {
    label: 'Belum dikirim',
    foreground: '!text-default',
    background: '!bg-red-10',
  },
  SENDING_TO_BKN: {
    label: 'Sudah dikirim',
    foreground: '!text-default',
    background: '!bg-green-10',
  },
  SENT_TO_BKN: {
    label: 'Sudah dikirim',
    foreground: '!text-default',
    background: '!bg-green-10',
  },
  ERROR_SEND: {
    label: 'Sudah dikirim',
    foreground: '!text-default',
    background: '!bg-green-10',
  },
}

const DEFAULT_COLOR = COLORS_PPK['NOT_RATED']

export function BadgeStatusPengirimanPPK({
  status,
}: BadgeStatusPengirimanProps) {
  const color = COLORS_PPK[status] ?? DEFAULT_COLOR
  return (
    <Badge
      variant="success"
      className={clsx([color.background, '!text-default'])}
    >
      <Text variant="body-sm" className="!font-semibold">
        {color?.label ?? 'Pelaksanaan Belum Selesai'}
      </Text>
    </Badge>
  )
}
